export default __webpack_public_path__ + "media/images/logo_email_etico-a7b19c098f4d49474eb05166eacccdac.png";